export default __webpack_public_path__ + "static/media/gallery_02.ef9fb150.jpg";